/** Format a string value so that it is always an array */
export const getValueArray = (value?: string | string[] | null) => {
  if (!value) return []
  if (typeof value === 'string') return [value]
  return value
}
